<ion-header mode="ios">
  <ion-toolbar mode="ios">
    <ion-buttons>
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" class="close-icon" src="assets/svg/close.svg"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title class="title">Message Drawer</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="clearAll()" class="clear-btn" [disabled]="!messages.length">Clear
        All</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list class="list">
    <ion-item class="list-item" *ngFor="let message of messages">
      <ion-label class="list-content">
        <h3>
          <ion-icon *ngIf="message.isError" class="error-icon" src="assets/svg/warning.svg"></ion-icon>
          <span
            [ngClass]="{'error': message.isError || (message.actionableAlert && message.fallAlertStatus === 'TAKE'), 'app-link': message.partsData[part]}"
            *ngFor="let part of message.parts" (click)="onLinkClick(part, message)">{{message.partsData[part] ||
            part}}</span>
        </h3>
        <p><span [ngClass]="{'app-link': message.partsData[part]}" *ngFor="let part of message.subParts"
            (click)="onLinkClick(part, message)">{{message.partsData[part] || part}}</span></p>

        <p class="alert-id">Alert ID: {{ message.alertId }}</p>
      </ion-label>
      <ion-button class="action-button" (click)="onSilenceClicked(message)" size="small" *ngIf="message.actionableAlert"
        [disabled]="message.processing">
        {{message.fallAlertStatus === 'RESOLVE' ? 'Resolve' : 'Take'}}
        <ion-icon *ngIf="message.fallAlertStatus === 'RESOLVE' && !message.processing" slot="end"
          name="open-outline"></ion-icon>
        <ion-spinner class="fall-alert-processing" slot="end" *ngIf="message.processing"></ion-spinner>
      </ion-button>
      <ion-note slot="end" class="message-note">{{ message.timestamp }}</ion-note>
    </ion-item>
    <ion-item *ngIf="!loading && !messages.length">
      No messages
    </ion-item>
  </ion-list>
</ion-content>
<ion-footer>
  <div class="message-footer" *ngIf="isLastUpdateLoading">
    Loading...
  </div>
  <div class="message-footer" *ngIf="lastUpdatedPCC !== '' && !isLastUpdateLoading">Last updated at
    {{lastUpdatedPCC}}</div>
</ion-footer>